import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { LineForm3 } from "../cmp/LineForm3";

/**
 * Props:
 *  - isOpen: booléen contrôlant l'affichage du modal
 *  - toggle: fonction pour fermer le modal (ex. () => setOpenFlag2(false))
 *  - data3, keyData: vos données existantes
 */
export function Modal3({ isOpen, toggle, data3, keyData }) {
  return (
    <div //className="modal-content modal-container"
    >
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={true}
        keyboard={true}
        className="pt-1 pb-1"
      >
        <ModalHeader toggle={toggle}>
          {keyData != null ? "Éditer une saisie" : "Ajouter une saisie"}
        </ModalHeader>
        <ModalBody className="pt-1">
          <LineForm3 closeModal={toggle} data3={data3} keyData={keyData} />
        </ModalBody>
      </Modal>
    </div>
  );
  /*}



import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LineForm3 } from "../cmp/LineForm3";
import { eventBus } from "../services/eventBusService";
import { loadCrms, removeCrm, setEditCrm } from "../store/actions/crmAction";

export function Modal3({ data3, keyData }) {
  const dispatch = useDispatch();
  const crms = useSelector((state) => state.crmReducer.crms);
  const crmIdxEdited = useSelector((state) => state.crmReducer.crmIdxEdited);

  const [isShown, setIsShown] = useState(true);

  const closeModal = () => {
    setIsShown(false);
    eventBus.emit("editing");
    eventBus.emit("added");
  };

  return (
    <div>
      <div
        className={`modal-wrapper ${isShown ? "" : "hide"}`}
        onClick={closeModal}
      >
        <div
          className="modal-content modal-container"
          onClick={(ev) => ev.stopPropagation()}
        >
          <LineForm3 closeModal={closeModal} data3={data3} keyData={keyData} />
        </div>
      </div>
    </div>
  );*/
}
